module.exports = __webpack_public_path__ + "img/DEALER_LEGEND_DESKTOP.598690f.jpg";